// extracted by mini-css-extract-plugin
export default {"mediumMobile":"(max-width: 480px)","mediumDesktop":"(max-width: 1180px)","logoWrapper":"Logo_logoWrapper__1ULQh","logo":"Logo_logo__329O6"};